import React from "react";
import { IModalOkCancelControllerReturn } from "./ModalOKCancelController";
import { t } from "i18next";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { ELng } from "../../../../../language/main/LanguageKeysEnums";

interface IProps {
  mokc: IModalOkCancelControllerReturn,
}

export const ModalOkCancel: React.FC<IProps> = (props): JSX.Element => {

  return (
    <>
      {props.mokc.show ? (
        <>
          <div
            className="justify-center items-center flex overflow-x-scroll overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
          >
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              <div className={"rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none " + props.mokc.css}>
                <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-3xl font-semibold"> { props.mokc.title} </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => props.mokc.setShow(false)}
                  >
                    <IoMdCloseCircleOutline size={32} />

                  </button>
                </div>
                <div className="relative p-6 flex-auto">
                  <p className="my-4 text-gray-800 text-lg leading-relaxed">
                  {props.mokc.text}
                  </p>
                </div>
    
                <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                  {props.mokc.isOkCancel? (
                    <button
                      className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => {
                        props.mokc.setResult(true)
                        props.mokc.setShow(false)
                      }}
                    >
                      {t(ELng.button_confirm.valueOf())}
                    </button>):<></>
                  }

                  <button
                    className="bg-blue-500 text-white active:bg-blue-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() =>{
                      props.mokc.setResult(false)
                      props.mokc.setShow(false)
                    }}
                  >
                    { props.mokc.isOkCancel? ( t(ELng.button_cancel.valueOf()) ):t(ELng.button_confirm.valueOf()) }
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}